/* ==========================================================================
   PanelAccommodation > Discounts
   ========================================================================== */

/* Modules */
const SelectClient = require('@bluekiri/alexandria-contrib-components/components/select/client/js/index');
const config = require('./config');

/**
 * onChangeDiscounts: funtion to be executed when update one select
 * @param {Object} instance instace of the panel
 * @returns void
 */
function onChangeDiscounts(instance) {
    const result = instance;
    let residentLabel = '';
    let bonusesLabel = '';

    if (result.resident) {
        residentLabel = result.resident.get().value !== '0' ? `| ${result.resident.get().label}` : '';
    }

    if (result.bonuses) {
        bonusesLabel = result.bonuses.get().value !== '0' ? `| ${result.bonuses.get().label}` : '';
    }

    result.infoDiscount = `${residentLabel} ${bonusesLabel}`;
    result.infoPanel = `${result.infoRooms} ${result.infoDiscount}`;

    // set info of the panel to input
    if (result.config.triggerInput) result.config.triggerInput.set(result.infoPanel);
}

/**
 * initRooms: export function: initialize the selects (resident, bonuses)
 * @param {Object} instance instace of the panel
 * @returns void
 */
function initDiscounts(instance) {
    const result = instance;

    const selectorResident = `${instance.selector} [data-type="${config().resident.config.data.type}"]`;
    const selectorBonuses = `${instance.selector} [data-type="${config().bonuses.config.data.type}"]`;

    const configSelect = {
        enableClick: true,
        choices: {
            searchEnabled: true,
            searchPlaceholderValue: '',
            loadingText: 'Cargando...',
            noResultsText: 'No se han encontrado resultados',
            noChoicesText: 'No hay opciones para selecionar',
            itemSelectText: 'Tocar para seleccionar'
        },
        onChange: [
            () => {
                onChangeDiscounts(instance);
            }
        ]
    };

    // init select resident
    result.resident = SelectClient(selectorResident, configSelect);

    // init select bonuses
    result.bonuses = SelectClient(selectorBonuses, configSelect);
}

module.exports = {
    initDiscounts
};
